import { on, off, fire } from "delegated-events";
import pillList from "@scripts/components/pill-list";

const closeOtherTabs = (activeTrigger) => {
  const container = activeTrigger.closest('[role="tablist"]');
  const otherTriggers = Array.from(container.querySelectorAll('[role="tab"][aria-selected="true"]')).filter(
    (x) => x !== activeTrigger,
  );

  otherTriggers.forEach((x) => closeTab(x));
};

const openTab = (trigger) => {
  const panel = document.getElementById(trigger.getAttribute("aria-controls"));

  trigger.setAttribute("aria-selected", "true");
  panel.setAttribute("aria-hidden", "false");

  fire(document.documentElement, "tablist:tabshow", { panelEl: panel });

  window.dispatchEvent(new Event("resize"));
};

const closeTab = (trigger) => {
  const panel = document.getElementById(trigger.getAttribute("aria-controls"));

  trigger.setAttribute("aria-selected", "false");
  panel.setAttribute("aria-hidden", "true");
};

const handleTab = (e) => {
  e.preventDefault();

  const trigger = e.target.closest('[role="tab"]');

  if (trigger.getAttribute("aria-selected") === "false") {
    openTab(trigger);
    closeOtherTabs(trigger);
    pillList.animatePillMarker(trigger.closest("[data-tablist]"));
  }
};

const handleTabMarkers = () => {
  document.querySelectorAll("[data-tablist]").forEach((el) => {
    pillList.animatePillMarker(el);
  });
};

export default {
  init: () => {
    const clickArgs = ["click", '[data-tablist] [role="tab"]', handleTab];

    off(...clickArgs);
    on(...clickArgs);

    window.removeEventListener("resize", handleTabMarkers);
    window.addEventListener("resize", handleTabMarkers);

    setTimeout(handleTabMarkers, 10);
  },
};
